module.exports = __webpack_public_path__ + "img/16.5b2002c9.png";